export const useLayout = defineStore('layout', () => {
  const isLoading = ref(true)
  const showHeader = ref(true)
  const showMobileMenu = ref(false)
  const showDesktopMenus = ref(true)
  const showTermsAndConditions = ref(false)
  const showFooter = ref(true)
  const showFooterBoxes = ref(true)
  const showPPTOToast = ref(true)

  return {
    isLoading,
    showHeader,
    showMobileMenu,
    showDesktopMenus,
    showTermsAndConditions,
    showFooter,
    showFooterBoxes,
    showPPTOToast,
  }
})
